import { Point } from 'components/site/general/singleSelect/SelectedMarkerV2/Point';
import { useIsKeyHeld } from 'components/site/general/singleSelect/SelectedMarkerV2/useIsKeyHeld';
import { useLocalConfig } from 'hooks/map/useLocalConfig';
import { IXY } from 'react-give-me-map/dist/utils/map/mapTypes';

interface Props {
    xyCoordinates: IXY[];
    color: string;
    minCoordinatesCount: number;
    onPointRemove: (index: number) => void;
}
export const RemovePoints = (props: Props) => {
    const xyCoordinates = props.xyCoordinates;

    const localConfig = useLocalConfig();
    const [isShiftDown] = useIsKeyHeld('Shift');

    const hiddenPoints = localConfig.useShiftForPolygonUpdate && !isShiftDown;

    if (xyCoordinates.length <= props.minCoordinatesCount) {
        return null;
    }

    return (
        <>
            {xyCoordinates.map((xyCoordinate, index) => {
                const x = xyCoordinate.x + 18;
                const y = xyCoordinate.y - 10;

                const id = x + '|' + y;
                return (
                    <div
                        key={id}
                        style={{
                            position: 'absolute',
                            left: x,
                            top: y,
                            display: 'inline-block',
                            visibility: hiddenPoints ? 'hidden' : 'visible'
                        }}
                        onClick={() => {
                            props.onPointRemove(index);
                        }}
                    >
                        <Point
                            className={'handle'}
                            width={16}
                            fontSize={12}
                            style={{ pointerEvents: 'all' }}
                            text={'-'}
                            color={'white'}
                        />
                    </div>
                );
            })}
        </>
    );
};
